/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Label_ComponentInputs */

const vi_combo_recipe_label_component = /** @type {(inputs: Combo_Recipe_Label_ComponentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành phần`)
};

/**

* @param {Combo_Recipe_Label_ComponentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_label_component = /** @type {((inputs?: Combo_Recipe_Label_ComponentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Label_ComponentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_label_component(inputs)
});